module.exports = __webpack_public_path__ + "static/media/Encryption.80ab8c47.svg";